import { render } from "./Vault.vue?vue&type=template&id=62629fee&scoped=true&ts=true"
import script from "./Vault.vue?vue&type=script&lang=ts"
export * from "./Vault.vue?vue&type=script&lang=ts"

import "./Vault.vue?vue&type=style&index=0&id=62629fee&scoped=true&lang=css"

import exportComponent from "/vercel/path1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62629fee"]])

export default __exports__